module.exports = __webpack_public_path__ + "img/resized-APP-0007-1.23c6e0f2.png";